// Utility function to map backend data to frontend expected format
export const normalizeRowData = (item: Record<string, unknown>, type: 'categories' | 'types' | 'segments' | 'regions' | 'localities') => {
  const normalized: Record<string, unknown> = {};

  // Map segment/seg field - based on actual data structure
  normalized.seg = item.segmentId || item.seg || item.segment || item.segmento || item.typeId || '';
  
  // Map category/type/locality name fields - use actual backend field names
  switch (type) {
    case 'categories':
      normalized.categorias = item.combinedName || item.name || item.categorias || '';
      break;
    case 'types':
      normalized.tipo = item.typeName || item.combinedName || item.name || item.tipo || '';
      break;
    case 'segments':
      normalized.segmento = item.segmento || item.segment || item.name || '';
      break;
    case 'regions':
      normalized.regiones = item.name || item.regionName || item.regiones || '';
      break;
    case 'localities':
      normalized.localidad = item.name || item.localityName || item.localidad || '';
      break;
  }

  // Map numeric fields with exact backend field names
  normalized.alojamientos = (item.count as number) || (item.alojamientos as number) || 0;
  normalized.plazas = (item.totalPlaces as number) || (item.plazas as number) || 0;
  normalized.habitaciones = (item.totalRooms as number) || (item.habitaciones as number) || 0;

  // Missing places/rooms (only sent for pre-registered / consolidated sources)
  if (item.withoutPlaces !== undefined) normalized.sinDatoPlazas = item.withoutPlaces;
  if (item.withoutRooms !== undefined) normalized.sinDatoHabitaciones = item.withoutRooms;

  // Calculate percentage values based on total response if available
  // For now, use the percentage field from backend (which seems to be accommodation percentage)
  normalized['a%'] = (item.percentage as number) || 0;
  normalized['p%'] = 0; // Will be calculated from totals if needed
  normalized['h%'] = 0; // Will be calculated from totals if needed

  if (process.env.NODE_ENV === 'development') {
    console.log(`🔍 Normalized ${type} data:`, { 
      original: item, 
      normalized,
      segmentId: item.segmentId,
      combinedName: item.combinedName 
    });
  }
  
  return normalized;
};

// Helper to normalize array of data with percentage calculations
export const normalizeTableData = (data: Record<string, unknown>[], type: 'categories' | 'types' | 'segments' | 'regions' | 'localities', totals?: Record<string, unknown>) => {
  if (!Array.isArray(data)) {
    console.warn(`🚨 Expected array for ${type}, got:`, typeof data, data);
    return [];
  }
  
  // Calculate totals if not provided
  const totalCount = (totals?.alojamientos as number) || data.reduce((sum, item) => sum + ((item.count as number) || 0), 0);
  const totalPlaces = (totals?.plazas as number) || data.reduce((sum, item) => sum + ((item.totalPlaces as number) || 0), 0);
  const totalRooms = (totals?.habitaciones as number) || data.reduce((sum, item) => sum + ((item.totalRooms as number) || 0), 0);
  
  return data.map(item => {
    const normalized = normalizeRowData(item, type);
    
    // Calculate percentages based on totals
    if (totalCount > 0) {
      normalized['a%'] = (((item.count as number) || 0) / totalCount);
    }
    if (totalPlaces > 0) {
      normalized['p%'] = (((item.totalPlaces as number) || 0) / totalPlaces);
    }
    if (totalRooms > 0) {
      normalized['h%'] = (((item.totalRooms as number) || 0) / totalRooms);
    }
    
    return normalized;
  });
};